angular.module('bizmetryApp').controller('ResetPasswordController', [
  '$scope', '$location', '$timeout', 'AuthService', 'dialogService',
  function ($scope, $location, $timeout, AuthService, dialogService) {

    // ── Leer token desde query params ────────────────────────────────────
    var token = ($location.search().token || '').trim();
    $scope.state = token.length > 0 ? 'form' : 'invalid';

    // ── View model ───────────────────────────────────────────────────────
    $scope.vm = {
      newPassword:  '',
      passwordValid: false,
      submitting:   false
    };

    // ── Callback del componente biz-password-input ───────────────────────
    $scope.onPasswordChange = function (value, valid) {
      $scope.vm.newPassword  = value;
      $scope.vm.passwordValid = valid && value.length > 0;
    };

    // ── Submit ───────────────────────────────────────────────────────────
    $scope.submit = function () {
      if (!$scope.vm.passwordValid || $scope.vm.submitting) return;

      $scope.vm.submitting = true;

      AuthService.resetPassword(token, $scope.vm.newPassword)
        .then(function () {
          $scope.vm.submitting = false;
          $scope.state = 'success';
          $timeout(function () { $location.path('/login'); }, 3000);
        })
        .catch(function (err) {
          $scope.vm.submitting = false;
          console.error('❌ Reset password error:', err);

          // 400 = token inválido o expirado → cambiar estado
          if (err && err.status === 400) {
            $scope.state = 'invalid';
            return;
          }

          // Otros errores → dialog
          var errorData = err && err.data ? err.data : null;
          var errorMessage = dialogService.formatErrorMessage(errorData || {
            error: 'Connection Error',
            message: 'Could not reach the server. Please check your connection and try again.',
            path: '/v1/api/bizmetry-account/reset-password',
            timestamp: new Date().toISOString()
          });

          dialogService.showErrorDialog('Password Reset Failed', errorMessage);
        });
    };

    // ── Navigation ───────────────────────────────────────────────────────
    $scope.goToLogin = function () {
      $location.path('/login');
    };
  }
]);